import {map, Observable, of} from 'rxjs';
import {BaseCollectionModel, SearchModel, YascEntityApiAdapterV3} from '@yasc/yasc-material-components';
import {RestApiService} from '../../../rest-api.service';
import {ApiV0Crm} from '../api.v0.crm';
import {
    ProjectContractCreateReq,
    ProjectContractDetailRes,
    ProjectContractMinRes,
    ProjectContractUReq,
} from '../../../../contracts/v0/crm/project-contract.contract';

export class ApiV0CrmProjectContract implements YascEntityApiAdapterV3<
    ProjectContractMinRes,
    ProjectContractDetailRes,
    ProjectContractCreateReq,
    ProjectContractUReq,
    number
> {
    readonly idKey = 'id' as const;
    readonly modelTypes = {
        row: ProjectContractMinRes,
        detail: ProjectContractDetailRes,
        create: ProjectContractCreateReq,
        patch: ProjectContractUReq,
    };
    readonly segment: string;

    constructor(v0: ApiV0Crm, private readonly rest: RestApiService) {
        this.segment = `${v0.segment}/project-contract`;
    }

    search(searchModel: SearchModel = new SearchModel({})): Observable<BaseCollectionModel<ProjectContractMinRes>> {
        return this.rest.post<SearchModel, BaseCollectionModel<ProjectContractMinRes>>(
            `${this.segment}/search`, ProjectContractMinRes, searchModel,
        );
    }

    detail(id: number): Observable<ProjectContractDetailRes> {
        return this.rest.get<ProjectContractDetailRes>(`${this.segment}/${id}`, ProjectContractDetailRes);
    }

    create(request: ProjectContractCreateReq): Observable<ProjectContractDetailRes> {
        return this.rest.post<ProjectContractCreateReq, ProjectContractDetailRes>(
            this.segment, ProjectContractDetailRes, request,
        );
    }

    patch(id: number, request: ProjectContractUReq): Observable<ProjectContractDetailRes> {
        return this.rest.patch<ProjectContractUReq, ProjectContractDetailRes>(
            `${this.segment}/${id}`, ProjectContractDetailRes, request,
        );
    }

    delete(ids: number[]): Observable<void> {
        const unique = [...new Set((ids ?? []).filter(id => id > 0))];
        if (!unique.length) return of(undefined);
        return this.rest.post<number[], unknown>(`${this.segment}/batch`, Object as any, unique).pipe(map(() => undefined));
    }
}
